import * as React from 'react';
import { toastr } from "react-redux-toastr";
import { cloneDeep } from 'lodash';
import { EmailsConfigurationService } from "src/share/services/emails-configuration";
import { IEmailConfiguration, initialEmailConfiguration } from 'src/share/types/emailsConfiguration';

const { useState, useEffect } = React;
export const useEmailsConfiguration = () => {
  const [data, setData] = useState<IEmailConfiguration[]>([]);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [emailSelected, setEmailSelected] = useState<IEmailConfiguration>(initialEmailConfiguration);

  const loadEmailsConfiguration = async () => {
    try {
      setLoading(true);
      const { results } = await EmailsConfigurationService.getAll();
      setData(results as IEmailConfiguration[]);
      setLoading(false);
    } catch {
      toastr.error("Error", "There was a problem loading the email configutation");
      setLoading(false);
    }
  }
  const handleEmailConfiguration = async () => {
    try {
      await EmailsConfigurationService.update(emailSelected);
      setData((prevState) => {
        const emailIndex = prevState.findIndex(emailConfig => emailConfig.emailId === emailSelected.emailId);
        const emailsConfiguration = cloneDeep(prevState);
        emailsConfiguration[emailIndex] = emailSelected;
        return emailsConfiguration;
      });
      setEmailSelected(initialEmailConfiguration);
      setShowModal(prevState => !prevState);
    } catch {
      toastr.error("Error", "There was a problem connecting to the server");
    }
  }
  const handleSelected = (value: string[] | boolean, field: string) => {
    setEmailSelected((prevState) => {
      const emailSelectedState = cloneDeep(prevState);
      emailSelectedState[field] = value;
      return emailSelectedState;
    });
  }
  const handleModal = (emailId: string) => {
    const emailSelectedState = data.find(emailConfig => emailConfig.emailId === emailId) as IEmailConfiguration;
    setEmailSelected(emailSelectedState);
    setShowModal(prevState => !prevState);
  }
  useEffect(() => {
    loadEmailsConfiguration();
  }, []);
  return [
    { data, emailSelected, isLoading, showModal },
    { handleEmailConfiguration, handleModal, handleSelected }
  ] as returned;
}

type returned = [
  IEmailsConfigurationState,
  {
    handleEmailConfiguration: () => Promise<void>;
    handleModal: (emailId) => void;
    handleSelected: (users: string[] | boolean) => void;
  }
];

interface IEmailsConfigurationState {
  data: IEmailConfiguration[];
  emailSelected: IEmailConfiguration;
  isLoading: boolean;
  showModal: boolean;
}